export const useProfileStore = defineStore(
  "profile-store",
  () => {
    const sessionStore = useSessionStore();
    const requestErrorHandler = useRequestErrorHandler();
    async function fetchProfile() {
      await isModuleReady(sessionStore);
      if (!sessionStore.isLoggedIn) return;

      try {
        await useRequest("users");
      } catch (error) {
        requestErrorHandler({
          error,
          rethrow: false,
        });
      }
    }

    return {
      fetchProfile,
    };
  },
  {
    persistedState: {},
  },
);
